export const AVALANCHE_CHAIN_ID = 43114;

export const TRANSFER_STEPS = {
  IDLE: 'idle',
  APPROVING: 'approving',
  BURNING: 'burning',
  WAITING_ATTESTATION: 'waiting-attestation',
  READY_TO_MINT: 'ready-to-mint',
  MINTING: 'minting',
  COMPLETED: 'completed',
  ERROR: 'error'
};

export const ATTESTATION_CHECK_INTERVAL = 5000;

export const ATTESTATION_TIMEOUT = 15 * 60 * 1000;

export const DEFAULT_GAS_LIMIT = {
  APPROVE: 100000n,
  DEPOSIT_FOR_BURN: 250000n,
  RECEIVE_MESSAGE: 350000n,
};

export const USDC_DECIMALS = 6;